export const ID = '273f0c3c-cc50-4196-a592-7d339be14e56';

export const NAME = 'Carousel';
